<!--店铺-->
<template>
  <div class="shop-container">
    <headerIndex/>
    <div class="search-content">
      <p class="SourceHanSansCN title"><span style="color: #FE273B;">{{ pName }}</span>
        <el-button class="search-full" @click="searchAllStack">搜全站</el-button>
        <el-button class="search-shop" @click="searchMineShop">搜本店</el-button>
        <el-input v-model="keyword" placeholder="关键字搜索" class="search-input" @keyup.enter.native="searchMineShop"/>
      </p>
      <div class="recommend-search">
        <el-link v-for="rec of recommendSearch" :underline="false" @click="checkRecommend(rec)">{{ rec }}</el-link>
      </div>
    </div>
    <div class="user-content">
      <p class="left-content">
        <el-avatar :src="shopDetail.bqwShop.img" :size="40"/>
        <span class="SourceHanSansCN" style="padding-left: 12px;">{{ shopDetail.bqwShop.name }}</span>
      </p>
      <p class="right-content">
        <el-link class="right-link" :underline="false"  @click="ContactCustomer"><i class="iconfont icon-bqw-customer"/>联系客服</el-link>
        <el-link class="right-link" :underline="false" v-if="!shopDetail.attentionShop" @click="followStore(1)">
          <i class="iconfont icon-bqw-follow"/>关注店铺
        </el-link>
        <el-link class="right-link" :underline="false" v-else @click="followStore(0)">
          <i class="iconfont icon-followed"/> 已关注
        </el-link>

        <el-link class="right-link" :underline="false" @click="dialogVisible=true"><i
            class="iconfont icon-bqw-shop2"/>店铺详情
        </el-link>
      </p>
    </div>
    <div class="navigator">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部产品" name=""/>
        <el-tab-pane v-for="(category,index) of categoryList" :label="category.name"
                     :name="JSON.stringify(category.id)"/>
      </el-tabs>
    </div>
    <div class="shop-content" :style="'min-height:'+min_height+'px;'">
      <div class="right-content">
        <i class="multiple" @click="changeSearchType">综合</i>
        <i class="multiple" style="padding-right: 30px;" @click="ascPrice">价格
          <i :class="sort==1 ? 'el-icon-caret-top isActive' : 'el-icon-caret-top'"/>
          <i :class="sort==2 ? 'el-icon-caret-bottom isActive' : 'el-icon-caret-bottom'"/>
        </i>
        <i class="multiple" style="padding-right: 30px;" @click="ascSale">销量
          <i :class="sort==3 ? 'el-icon-caret-top isActive' : 'el-icon-caret-top'"/>
          <i :class="sort==4 ? 'el-icon-caret-bottom isActive' : 'el-icon-caret-bottom'"/>
        </i>
      </div>
      <div class="recommend" v-if="recommends.length>0">
        <el-row :gutter="16">
          <el-col :span="5" v-for="recommend of recommends">
            <div @click="productDetails(recommend)">
              <el-image style="width: auto; height: 230px;border-radius: 8px;" :src="recommend.image" fit="contain"/>
              <p class="recommend-title SourceHanSansCN">{{ recommend.name }}</p>
              <div class="preferential-amount" v-if="recommend.usingDoor">
                <div class="preferential">满{{ recommend.usingDoor }}减{{ recommend.preferentialAmount }}</div>
              </div>
              <p class="recommend-price SourceHanSansCN"><span>￥</span>{{ parseFloat(recommend.price).toFixed(2) }}
              </p>
            </div>
          </el-col>
        </el-row>
        <!-- 分页 -->
        <page :total="tablePage.total" class="pagination" :page="tablePage.currentPage"
              @currentPage="currentPage" :limit="tablePage.pageSize"
              style="padding: 0px 25px 15px 10px;"/>
      </div>
      <div class="recommend" v-else>
        <el-empty description="暂无商品"/>
      </div>
    </div>
    <el-dialog title="店铺详情" :visible.sync="dialogVisible" width="30%" class="shop-dialog">
      <el-descriptions :column="1" :colon="false">
        <el-descriptions-item label="店铺评级">
          <el-rate v-model="shopDetail.bqwShop.shopRating" disabled :colors="['#FE273B', '#FE273B', '#FE273B']"/>
        </el-descriptions-item>
        <el-descriptions-item label="所在地区">{{ shopDetail.bqwShop.city || '-' }}</el-descriptions-item>
        <el-descriptions-item label="开店时间">{{ shopDetail.bqwShop.shopOpenTime || '-' }}</el-descriptions-item>
        <el-descriptions-item label="证照信息">
          <div v-if="shopDetail.bqwShop.yingyezhizhaoImg">
            <el-image v-for="img of shopDetail.bqwShop.yingyezhizhaoImg" fit="contain"
                      :preview-src-list="shopDetail.bqwShop.yingyezhizhaoImg" :src="img"
                      style="width: 128px;height: 84px;"/>
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="荣誉资质"></el-descriptions-item>
        <el-descriptions-item label="店铺动态">
          <el-link :underline="false" type="primary">查看</el-link>
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>
    <Hang/>
    <home_footer/>
  </div>
</template>
<script>
import headerIndex from "@/components/header/headerIndex";
import home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hang";
import page from "@/components/page/pages";
import cityJson from "@/static/cityJson.json";
import {
  newShopClass,
  joinShop,
  pcShopGoodsForSearchComprehensive,
  saveCollect,
  removeCollect,
  hotSearchKeywords
} from '@/api/cloudServiceApi'

export default {
  name: "shop",
  components: {Hang, headerIndex, home_footer, page},
  data() {
    return {
      id: 0,
      min_height: document.documentElement.clientHeight - 275,
      recommendSearch: [],
      activeName: '',
      pName: '',
      keyword: '',
      recommends: [],
      /*分页*/
      tablePage: {
        currentPage: 1,
        pageSize: 15,
        total: 0,
      },
      shopDetail: {bqwShop: {},},
      dialogVisible: false,
      cid: 0,
      cityList: [],
      serviceList: null,
      serviceData: null,
      categoryList: [],
      sort: 0,
    }
  },
  beforeMount() {
    this.pName = this.$route.query.pName;
    this.activeName=this.$route.query.activeName;
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
    if (sessionStorage.getItem('setPositioning'))
      this.cityList = JSON.parse(sessionStorage.getItem('setPositioning'));
    else {
      let cityList = JSON.parse(sessionStorage.getItem('locationInfo'));
      for (let li of cityJson) {
        if (cityList.short_name == li.short_name)
          this.cityList = li;
      }
    }
    if (sessionStorage.getItem('serviceList'))
      this.serviceList = JSON.parse(sessionStorage.getItem('serviceList'));
    if (sessionStorage.getItem('serviceData'))
      this.serviceData = JSON.parse(sessionStorage.getItem('serviceData'));
  },
  methods: {
    /*搜索本店商品*/
    searchMineShop() {
      this.tablePage.currentPage = 1;
      this.sort = 0;
      this.getNewHomeSearch();
    },
    /*搜索全站商品信息*/
    searchAllStack() {
      if (this.keyword) {
        this.$router.push({
          path: '/cloudPlatform/AllService',
          query: {
            pName: this.pName,
            keyword: this.keyword
          }
        })
      } else
        this.$message.error('请输入关键词搜索。');
    },
    /*切换商品分类*/
    handleClick(tab, event) {
      this.tablePage.currentPage = 1;
      this.getNewHomeSearch();
    },
    //切换分页
    currentPage(page) {
      this.tablePage.currentPage = page;
      this.getNewHomeSearch();
    },
    /*搜索--价格*/
    ascPrice() {
      if (this.sort != 1) {
        this.sort = 1;
      } else {
        this.sort = 2;
      }
      this.tablePage.currentPage = 1;
      this.getNewHomeSearch();
    },
    /*搜索--销量*/
    ascSale() {
      if (this.sort != 4) {
        this.sort = 4;
      } else {
        this.sort = 3;
      }
      this.tablePage.currentPage = 1;
      this.getNewHomeSearch();
    },
    /*切换综合查询*/
    changeSearchType() {
      this.sort = 0;
      this.tablePage.currentPage = 1;
      this.getNewHomeSearch();
    },
    /*店铺内es商品搜索--综合*/
    getNewHomeSearch() {
      pcShopGoodsForSearchComprehensive({
        page: this.tablePage.currentPage,//分页
        pageLimit: this.tablePage.pageSize,/*每页条数*/
        pid: this.activeName ? parseInt(this.activeName) : 0,/*分类id*/
        shopId: this.$route.query.id,/*店铺id*/
        shopType: this.shopDetail.bqwShop.shopType,/*店铺类型*/
        userId: this.cid != 0 && this.cid != undefined ? this.cid : 0,/*用户id*/
        sort: this.sort,/*排序方式 0 默认 综合 、1：价格升序，2：价格降序，3：销量升序，4：销量降序*/
        keyword: this.keyword,/*关键字*/
      }).then(res => {
        if (res.code == 200) {
          this.recommends = res.content.BqwGoods;
          this.tablePage.total = res.content.totalNum;
        }
      })
    },
    /*店铺详情*/
    shopDetails() {
      joinShop({
        request: 'form',
        shopId: this.$route.query.id,
        userId: this.cid != 0 && this.cid != undefined ? this.cid : 0,
        uid: this.cid != 0 && this.cid != undefined ? this.cid : 0
      }).then(res => {
        if (res.code == 200) {
          this.shopDetail = res.content;
          this.getNewHomeSearch();
        }
      })
    },
    /*产品详情*/
    productDetails(rows) {
      this.$router.push({
        path: '/cloudPlatform/productDetails',
        query: {
          id: rows.id,
          pName: this.pName,
          nextName: '服务平台'
        }
      })
    },
    /*店铺商品分类*/
    getNewShopClass() {
      newShopClass({
        shopId: this.$route.query.id,
        request: 'form',
        uid: this.cid != 0 && this.cid != undefined ? this.cid : 0,
      }).then(res => {
        if (res.code == 200) {
          this.categoryList = res.content.categoryList;
        }
      })
    },
    /*关注店铺*/
    followStore(status) {
      /*关注店铺*/
      if (status == 1) {
        saveCollect({
          request: 'form', id: this.$route.query.id, shopType: this.shopDetail.bqwShop.shopType, type: 2,
          cid: this.cid != 0 && this.cid != undefined ? this.cid : 0,
          userId: this.cid != 0 && this.cid != undefined ? this.cid : 0,
        }).then(res => {
          if (res.code == 200) {
            this.$message.success(res.msg)
            this.shopDetails();
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {/*取消关注*/
        removeCollect({
          delType: 1, ids: this.$route.query.id, shopType: this.shopDetail.bqwShop.shopType, request: 'form', type: 2,
          cid: this.cid != 0 && this.cid != undefined ? this.cid : 0,
          userId: this.cid != 0 && this.cid != undefined ? this.cid : 0
        }).then(res => {
          if (res.code == 200) {
            this.$message.success(res.msg)
            this.shopDetails();
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    /*获取搜索推荐*/
    getHotSearchKeywords() {
      hotSearchKeywords().then(res => {
        if (res.code == 200) {
          this.recommendSearch = res.content.list;
        }
      })
    },
    /*键入推荐搜索*/
    checkRecommend(val) {
      this.keyword = val;
    },
    /*联系客服*/
    ContactCustomer(){
      let routeData = this.$router.resolve({
        name: "onlineService",
        path: '/onlineService/index',
        query:{
          id:this.shopDetail.bqwShop.id
        }
      });
      window.open(routeData.href, '_blank')
    }
  },
  mounted() {
    this.getHotSearchKeywords();
    this.getNewShopClass();
    this.shopDetails();
  },
}
</script>
<style scoped>
.shop-container >>> .shop-content .el-collapse {
  border-top: 1px solid #EEEEEE;
  border-bottom: 1px solid #EEEEEE;
  border: 1px solid #EEEEEE;
}

.shop-container >>> .shop-content .el-aside .el-link.el-link--default {
  padding: 20px 0px 0px 20px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  font-size: 16px;
  color: #333333;
}

.shop-container >>> .shop-content .el-collapse-item__header {
  background-color: #F1F1F1;
  color: #333333;
  border-bottom: 1px solid #dddddd;
  font-size: 18px;
}

.shop-container >>> .search-content .el-input__inner {
  border-color: #FE273B;
}

.shop-container >>> .search-content .el-input__inner:hover {
  border-color: #FE273B;
}

.shop-container >>> .shop-content .el-card__body, .el-main {
  padding: 0px 0px 0px 20px;
}

.shop-dialog >>> .el-dialog__body {
  border-top: 1px solid #EEEEEE;
  padding: 16px 20px 30px;
  color: #333333;
  font-size: 14px;
  word-break: break-all;
}

.shop-dialog >>> .el-dialog__title {
  line-height: 24px;
  font-size: 18px;
  color: #303133;
  font-weight: 600;
}

.shop-dialog >>> .el-dialog__header {
  padding: 15px 20px 10px;
}

.shop-dialog >>> .el-descriptions-item__label:not(.is-bordered-label) {
  margin-right: 50px;
  font-size: 16px;
  color: #333;
}

.shop-dialog >>> .el-descriptions-item__container .el-descriptions-item__content {
  font-size: 16px;
  color: #333;
}

.shop-dialog >>> .el-rate__icon {
  font-size: 22px;
  margin-right: 0px;
}

.shop-dialog >>> .el-link.el-link--primary {
  color: #0067DD;
  font-size: 16px;
}

.shop-dialog >>> .el-link.el-link--primary:hover {
  color: #0067DD;
  font-size: 16px;
}

.shop-container .shop-content .recommend .el-col-5 {
  width: 20%;
}

.shop-container >>> .el-tabs__header {
  margin: 0 0 0px;
}

.shop-container >>> .navigator .el-tabs__nav-wrap::after {
  height: 2px;
  background-color: #1E4165;
}

.shop-container >>> .navigator .el-tabs__active-bar {
  background-color: #ffffff;
}

.shop-container >>> .navigator .el-tabs__item {
  padding: 0 30px 0px 30px;
  height: auto;
  line-height: normal;
  margin: 10px 0px;
  font-size: 16px;
  color: #ffffff;
  border-right: 2px solid #ffffff;
}

.shop-container >>> .navigator .el-tabs--bottom .el-tabs__item.is-bottom:last-child,
.shop-container >>> .navigator .el-tabs--bottom .el-tabs__item.is-top:last-child,
.shop-container >>> .navigator .el-tabs--top .el-tabs__item.is-bottom:last-child,
.shop-container >>> .navigator .el-tabs--top .el-tabs__item.is-top:last-child {
  border-right: none;
}

.shop-container >>> .navigator .el-tabs--bottom .el-tabs__item.is-bottom:nth-child(2),
.shop-container >>> .navigator .el-tabs--bottom .el-tabs__item.is-top:nth-child(2),
.shop-container >>> .navigator .el-tabs--top .el-tabs__item.is-bottom:nth-child(2),
.shop-container >>> .navigator .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
  padding-left: 0;
}
</style>
<style scoped lang="scss">
.shop-container {
  background: #FFFFFF;

  .navigator {
    background: #1E4165;
    padding: 5px 18%;
    min-width: 76rem;
    .link-white {
      color: #ffffff;
      font-size: 16px;
      margin: 0px 0px;
    }

    .el-divider {
      background: #ffffff;
      width: 2px;
      margin: 0px 30px;
    }
  }

  .user-content {
    background: #1C2D3F;
    padding: 10px 18%;
    min-width: 76rem;
    .left-content {
      color: #fff;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: left;
      cursor: pointer;
      margin-block-start: 0em;
      margin-block-end: 0em;
      font-size: 16px;
      float: left;
    }

    .right-content {
      display: flex;
      width: 40%;
      justify-content: right;
      margin-left: auto;
      color: #ffffff;
      margin-block-start: 1em;
      margin-block-end: 0.5em;

      .right-link {
        margin-left: 45px;
        color: #ffffff;

        .icon-bqw-shop2, .icon-bqw-customer, .icon-bqw-follow,icon-followed {
          color: #ffffff;
          font-size: 16px;
          padding-right: 5px;
        }
      }
    }
  }

  .shop-content {
    padding: 20px 18%;
    min-width: 76rem;
    background: #FFFFFF;
    .left-icon {
      width: 5px;
      height: 5px;
      background: #FE273B;
      float: left;
      margin: 0px 10px 0px 20px;
    }

    .right-content {
      background: #F1F1F1;
      padding: 12px 30px;
      display: flex;

      .multiple {
        font-style: normal;
        color: #333333;
        font-size: 16px;
        padding: 5px 20px;
        border: 1px solid #DDDDDD;
        margin-right: 20px;
        cursor: pointer;

        .el-icon-caret-top {
          position: absolute;
          margin-top: -3px;
          color: #999999;
        }

        .el-icon-caret-top:hover {
          color: #0067DD;
        }

        .el-icon-caret-bottom {
          position: absolute;
          margin-top: 6px;
          color: #999999;
        }

        .el-icon-caret-bottom:hover {
          color: #0067DD;
        }

        .isActive {
          color: #1637FF;
        }
      }

      .el-link-red {
        color: #FE273B;
        font-size: 18px;
      }

      .el-icon--sort {
        font-style: normal;
        color: #333333;
        font-size: 18px;
        padding: 5px 20px;
        margin-right: 20px;

        .el-icon-caret-top {
          position: absolute;
          margin-top: -2px;
          font-size: 14px;
          color: #999999;
        }

        .el-icon-caret-top:hover {
          color: #0067DD;
        }

        .el-icon-caret-bottom {
          position: absolute;
          margin-top: 6px;
          color: #999999;
          font-size: 14px;
        }

        .el-icon-caret-bottom:hover {
          color: #0067DD;
        }

        span {
          padding-right: 5px;
        }
      }
    }

    .recommend {
      padding: 20px 10px;

      .el-col-5 {
        width: 20%;
        padding-bottom: 20px;
        min-height: 345px;

        .recommend-title {
          margin-block-start: 0;
          margin-block-end: 0;
          font-size: 16px;
          color: #333333;
          padding: 0px 0px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          word-wrap: break-word;
          word-break: break-all;
        }

        .recommend-price {
          font-size: 18px;
          color: #FE273B;
          margin-block-start: 0;
          margin-block-end: 0;

          span {
            font-size: 14px;
            padding-right: 3px;
          }
        }

        .preferential-amount {
          cursor: pointer;
          line-height: 24px;
          text-align: center;
          font-size: 14px;
          color: #FE273B;

          .preferential {
            background: url("~@/assets/img/cloud/coupon.png");
            width: 120px;
            height: 24px;
            background-size: 100% 100%;
          }
        }
      }
    }
  }

  .search-content {
    padding: 0px 18%;
    min-width: 76rem;
    background: #FFFFFF;
    .title {
      font-size: 36px;
      cursor: context-menu;
      margin-block-start: 0px;
      margin-block-end: 0em;
      padding-top: 1em;

      .search-input {
        width: 40%;
        float: right;
        display: flex;
        margin-top: 7px;
      }

      .search-shop {
        float: right;
        background: #FE273B;
        color: #ffffff;
        font-size: 16px;
        border: 1px solid #FE273B;
        margin: 7px 5px 0px 5px;
        padding: 11px 10px;
      }

      .search-full {
        float: right;
        background: #0067DD;
        color: #ffffff;
        font-size: 16px;
        border: 1px solid #0067DD;
        margin: 7px 0px 0px 5px;
        padding: 11px 10px;
      }
    }

    .recommend-search {
      width: max-content;
      margin-block-start: 0em;
      padding-top: 10px;
      margin-block-end: 0em;
      height: 40px;
      display: flex;
      flex-wrap: wrap;
      align-items: baseline;
      justify-content: left;
      padding-left: 47%;

      .el-link {
        margin-right: 20px;
        font-size: 14px;
        color: #666666;
      }
    }
  }
}
</style>